import React from "react";

const Footer = () => {
  return (
    <footer>
      <div>
        <h1>TechyStar</h1>
        <p>@all right reserved</p>
      </div>

      <div>
        <h5>Follow Us</h5>
        <div>
          <a href="https://youtube.com/6packprogrammer" target={"blank"}>
            Youtube
          </a>
          <a href="https://instagram.com/rohit_gupta_0101?igshid=MzNlNGNkZWQ4Mg==" target={"blank"}>
            Instagram
          </a>
          <a href="https://github.com/Rohit171020" target={"blank"}>
            Github
          </a>
          <a href="https://www.linkedin.com/in/rohit-gupta-16a964200/" target={"blank"}>
          Linkedin
          </a>
      </div>
      </div>
    </footer>
  );
};

export default Footer;